export default {
  state: {
    meterConfigs: [],
    tempMeterConfigIds: null,
    meterConfigsMeta: {},
  },
  getters: {
    meterConfigs: state => state.meterConfigs,
    tempMeterConfigIds: state =>
      state.tempMeterConfigIds
        ? state.tempMeterConfigIds?.id
        : JSON.parse(localStorage.getItem('tempMeterConfigIds') || '{}')?.id,
    meterConfigsMeta: state => state.meterConfigsMeta,
  },
  mutations: {
    SET_METER_CONFIGS(state, payload) {
      state.meterConfigs = payload
    },
    ADD_NEW_METER_CONFIG(state, payload) {
      state.meterConfigs.push(payload)
    },
    REMOVE_METER_CONFIGS(state, payload) {
      state.meterConfigs = state.meterConfigs.filter(
        meterConfig => !payload.includes(meterConfig.cuid)
      )
    },
    SET_TEMP_METER_CONFIG_IDS(state, payload) {
      state.tempMeterConfigIds = payload
      localStorage.setItem('tempMeterConfigIds', JSON.stringify(payload))
    },
    DELETE_TEMP_METER_CONFIG_IDS(state) {
      state.tempMeterConfigIds = null
      localStorage.removeItem('tempMeterConfigIds')
    },
    SET_METER_CONFIGS_META(state, payload) {
      state.meterConfigsMeta = payload
    },
    SET_METER_CONFIG_TARIFF_TYPE(state, payload) {
      const findMeterConfig = state.meterConfigs.find(
        meter => meter.id === payload.id
      )
      if (findMeterConfig) {
        findMeterConfig.tariff_type = payload.tariff_type
      }
    },
  },
  actions: {
    setMeterConfigs({ commit }, payload) {
      commit('SET_METER_CONFIGS', payload)
    },
    addNewMeterConfig({ commit }, payload) {
      commit('ADD_NEW_METER_CONFIG', payload)
    },
    removeMeterConfigs({ commit }, cuid) {
      commit('REMOVE_METER_CONFIGS', cuid)
    },
    setTempMeterConfigIds({ commit }, payload) {
      commit('SET_TEMP_METER_CONFIG_IDS', payload)
    },
    deleteTempMeterConfigIds({ commit }) {
      commit('DELETE_TEMP_METER_CONFIG_IDS')
    },
    setMeterConfigsMeta({ commit }, payload) {
      commit('SET_METER_CONFIGS_META', payload)
    },
    setMeterConfigTariffType({ commit }, payload) {
      commit('SET_METER_CONFIG_TARIFF_TYPE', payload)
    },
  },
}
